import integration from 'src/lib/api/integration';
import jira from 'src/lib/api/jira';
import pd from 'src/lib/api/pagerduty';
import { textifyError } from 'src/lib/error';

export function findExternalReference(issueKey, incident) {
  const { external_references } = incident || {};
  return (external_references || []).find(er => er && er.external_id === issueKey);
}

async function removeJiraExternalReferenceFromIncident(incidentFromSidebar, incidentFromPublicApi, issueKey) {
  try {
    const { id: incidentId } = {
      ...incidentFromPublicApi || {},
      ...incidentFromSidebar || {},
    };

    if (!incidentId) {
      return {};
    }

    const incident = await pd.getIncident(incidentId, { include: ['external_references'] });
    const { id: externalReferenceId } = findExternalReference(issueKey, incident) || {};

    if (externalReferenceId) {
      await pd.removeIncidentExternalReference(incident.id, externalReferenceId);
      return { successMessage: 'External reference was removed from incident' };
    }

    return { };
  } catch (e) {
    return { errorMessage: textifyError(['Failed to remove external reference from incident', e]) };
  }
}

async function removePagerDutyPropertyFromIssue({ incident }, issueKey) {
  try {
    if (!incident) {
      return { };
    }

    await Promise.all([
      jira.setIssueProperty(issueKey, 'pagerdutyIncident', {}),
      jira.setIssueProperty(issueKey, 'pagerduty', {}),
    ]);

    return { successMessage: 'PagerDuty property was removed from issue' };
  } catch (e) {
    return { errorMessage: textifyError(['Failed to remove PagerDuty property from issue', e]) };
  }
}

async function removeIncidentIssueMappingFromService(byService, issueKey) {
  if (!byService.incident) { return {}; }

  try {
    const { incident_issue_mapping: { id: mapping_id } } = await integration.getIncidentIssueMappingByIssueKey(issueKey);
    await integration.removeIncidentIssueMapping(mapping_id);
    return { successMessage: 'Issue was unlinked' };
  } catch (e) {
    return { errorMessage: textifyError(['Failed to remove PagerDuty property from issue', e]) };
  }
}

export async function unlink(linkedIncident, issueKey) {
  const { bySidebarInfo, byId, byService } = linkedIncident;

  const results = await Promise.all([
    removeJiraExternalReferenceFromIncident(bySidebarInfo.incident, byId.incident, issueKey),
    removePagerDutyPropertyFromIssue(byId, issueKey),
    removeIncidentIssueMappingFromService(byService, issueKey),
  ]);

  const errorMessage = results.map(r => r.errorMessage).filter(x => x).join('. ');
  const successMessage = results.map(r => r.successMessage).filter(x => x).join('. ');

  return {
    errorMessage,
    successMessage
  };
}
